import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Template from "./Template";

const Notes = props => (
  <Template
    subtitle="Instrukcja"
    navigationLeft={[
      <button
        onClick={() => {
          props.history.push("/");
          window.scrollTo(0, 0);
        }}
        className="button is-medium"
      >
        Wstecz
      </button>
    ]}
    navigationRight={[
      <button
        onClick={() => {
          props.history.push("/co_dalej");
          window.scrollTo(0, 0);
        }}
        className="button is-danger is-medium"
      >
        Dalej
      </button>
    ]}
  >
    <p>
      Wypełnienie przygotowanej przez nas ankiety zajmie Państwu ok. 20 minut.
    </p>
    <p>
      Na ekranie komputera będą pojawiać się pytania i instrukcje, w jaki sposób
      należy udzielać odpowiedzi. W dolnej części monitora umiejscowione będą
      klawisze:
    </p>
    <ul>
      <li>
        &quot;wstecz&quot;- wybór tego klawisza spowoduje przejście do
        poprzedniej strony z pytaniami,
      </li>
      <li>
        &quot;dalej&quot;- wybór tego klawisza spowoduje przejście do następnej
        strony z pytaniami.
      </li>
    </ul>
    <p>
      Szanowni Państwo prosimy pamiętać, że brak odpowiedzi na pytania oznaczone
      jako wymagane uniemożliwi zapisanie zgłoszenia w naszej bazie danych. Po
      zakończeniu rejestracji otrzymają Państwo maila z potwierdzeniem
      rejestracji.
    </p>
    <p>
      Pytania zawarte w kwestionariuszu pozwolą nam uzyskać informacje na temat
      Państwa upodobań kulinarnych, a także produktów które możemy Państwu
      podawać do oceny lub nie.
    </p>
  </Template>
);
Notes.propTypes = {
  history: PropTypes.shape().isRequired
};
export default withRouter(Notes);



// WEBPACK FOOTER //
// ./src/components/pages/Notes.js